import React, { useState, useEffect } from 'react';
import { Gallery } from "react-grid-gallery";
import { styled } from '@mui/system';

const PageContainer = styled('div')({
  display: 'block',
  width: '100%',
  minWidth: '10vw',
  alignContent: 'center',
});

const GridGallery = ({ imageUrls, handleImageClick }) => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    const images = imageUrls.map((url, index) => {
      return {
        src: url,
        caption: `Image ${index + 1}`,

      };
    });
    setImages(images);
    console.log(images);
  }, [imageUrls]);

  return (
    <PageContainer>
      <Gallery rowHeight={350} images={images} onClick={(index) => handleImageClick(index)} />
    </PageContainer>
  );
};

export default GridGallery;